
import React, { useEffect, useState } from 'react';
import { isNumeric, isMonthAndYearEmpty, getStatusFlagValue, getButtonDisabledStates } from '../Custom/Custom'
import messages from '../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from '../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';


function WholeSalePriceForAgricultureItemsofHapurMandiData({
  hapurMandiItems,
  monthName,
  yearName,
  config,
  resetMothAndYearField,
  payload,
  userInfoObject,
  dateName,
  districtCode,
  storedLanguage,
  othersData,
  titlesData
}) {

  const navigate = useNavigate();
  const [itemData, setItemData] = useState({});
  let srNo = 0;
  let isDisable = false;
  let districtAndDivision = false;
  const {
    isSaveBtnDisable,
    isSubmitBtnDisable,
    isAcceptBtnDisable,
    isRejectBtnDisable
  } = getButtonDisabledStates(payload, userInfoObject);
  let headQuarterRemark=[
    'Price is Too Low.',
	  'Price is too High.',
	  'Price does not match with unit.' ,
	  'Price does not match with variety.',
    'Others.'
  ]
  let otherRemark=[
    'Production is low',
    'Production is high',
    'Less supply',
    'High supply',
    'Not Available.',
    'On sale.',
    'Seasonal effect',
    'Discounted Item',
    'Other.'
  ]


  useEffect(() => {
    const initialData = {};
    hapurMandiItems.forEach(item => {
      initialData[item.itemCode] = {
        price: item.price,
        itemCode: item.itemCode,
        itemName: item.itemName,
        statusFlag: item.statusFlag,
        itemUnitName: item.itemUnitName,
        itemVarietyName: item.itemVarietyName,
        comment: item.comment,
        // remark_text:"demo_reamrk_text",

        style: {
          borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) black',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 3px'
        },
        isRequiredRemark: false,
        isRejectStatus: item.statusFlag === '6'

      };

    });
    setItemData(initialData);
  }, [hapurMandiItems]);


  // Table Header
  const renderHeader = (i) => (
    <thead key={`thead-${i}`}>
      <tr>
        <th class="text-center">{storedLanguage === 'hi' ? othersData.hi.SERIAL_NO : othersData.en.SERIAL_NO}</th>
        <th class="text-center" style={{width: '100px'}}>{storedLanguage === 'hi' ? othersData.hi.ITEM_NAME : othersData.en.ITEM_NAME}</th>
        <th class="text-center">{storedLanguage === 'hi' ? othersData.hi.VARITRY_NAME : othersData.en.VARITRY_NAME}</th>
        <th class="text-center">{storedLanguage === 'hi' ? titlesData.hi.UNIT : titlesData.en.UNIT}</th>
        <th class="text-center">{storedLanguage === 'hi' ? othersData.hi.CURRENT_PRICE : othersData.en.CURRENT_PRICE}</th>
        <th class="text-center">{storedLanguage === 'hi' ? othersData.hi.REMARKS : othersData.en.REMARKS}</th>
        <th class="text-center">{storedLanguage === 'hi' ? othersData.hi.REJECT_STATUS : othersData.en.REJECT_STATUS}</th>
      </tr>
    </thead>
  );


  //Handle Price On change   
  const handlePriceChange = (itemCode, field, newValue) => {

    if (!(isMonthAndYearEmpty(monthName, yearName))) {
      return;
    }

    let isRequiredRemark = false;

    if (field === 'price' && !isNumeric(newValue)) {
      toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
      newValue = '';
    }


    if (field === 'comment' && itemData[itemCode].isRequiredRemark === false && newValue === '' && itemData[itemCode].comment === '') {
      isRequiredRemark = true

    }


    setItemData(prevItemData => {
      const updatedItemData = {
        ...prevItemData,
        [itemCode]: {
          ...prevItemData[itemCode],
          [field]: newValue,
          'isRequiredRemark': isRequiredRemark
        }
      };

      return updatedItemData;
    });


  };


  //Handle validate Item Price
  const validateItemVariationPrice = (itemCode, field, newValue, average, variation) => {

    if (!(isMonthAndYearEmpty(monthName, yearName))) {
      return;
    }
    let dynamicStylesForTextBox = {}
    let isRequiredRemark = false

    if (newValue !== 0) {
      let dif = average * variation / 100;
      if (variation === 0 || dif === 0) {
        return;
      }
      if (newValue > (parseFloat(average) + dif) || newValue < (average - dif)) {
        toast.error(messages.VARIATION_MSG, messages.COLOR_RED);
        dynamicStylesForTextBox = {
          borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 6px'
        }
        newValue = dynamicStylesForTextBox
        if (itemData[itemCode].comment === 'NQ' || itemData[itemCode].comment === '') {
          isRequiredRemark = true
        }

      } else {

        dynamicStylesForTextBox = {
          borderColor: '#dcdfe1',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 6px'
        }
        isRequiredRemark = false
        newValue = dynamicStylesForTextBox


      }
    }
    setItemData(prevItemData => ({
      ...prevItemData,
      [itemCode]: {
        ...prevItemData[itemCode],
        [field]: newValue,
        'isRequiredRemark': isRequiredRemark
      }
    }));

  }



  //handle reject check box checked
  const handleCheckboxChange = (itemCode, field, newValue) => {
    if (!(isMonthAndYearEmpty(monthName, yearName))) {
      return;
    }
    let isRequiredRemark = (itemData[itemCode]?.comment  && itemData[itemCode]?.comment !=='NQ'  ? false : true); //required validation for Remarks
    setItemData(prevItemData => ({
      ...prevItemData,
      [itemCode]: {
        ...prevItemData[itemCode],
        [field]: !prevItemData[itemCode][field],
        'isRequiredRemark': isRequiredRemark
      }
    }));

  }



  //handle reject check box length
  const checkBoxcheckedLength = () => {
    const filteredData = Object.fromEntries(
      Object.entries(itemData).filter(([key, value]) => value.isRejectStatus === true)
    );
    return Object.keys(filteredData).length
  }

  // Handle Reset formData
  const resetForm = () => {

    const initialData = {};
    hapurMandiItems.forEach(item => {
      initialData[item.itemCode] = {
        price: '',
        itemCode: item.itemCode,
        itemName: item.itemName,
        statusFlag: item.statusFlag,
        itemUnitName: item.itemUnitName,
        itemVarietyName: item.itemVarietyName,
        comment: '',
        isRequiredRemark: false,
        isRejectStatus: false,


      };

    });
    setItemData(initialData);
    resetMothAndYearField()
  }


  // handle save and update form data
  const handleSaveHapurMandiFormData = async (e, buttonType) => {
    const customItemCodes = [];
 
    if(dateName==='' || yearName===''){
      toast.error('Please Select Date', messages.COLOR_RED);
      return false;
    }

    if(districtCode===''){
      toast.error('Please Select District', messages.COLOR_RED);
      return false; 
    }
    let allData = itemData;
    let clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel) //button click status flag
    let check = 0;
    let statusFlag = '';
    for (let itemCode in allData) {

      let price = allData[itemCode].price;
      let comment = allData[itemCode].comment;

      let source = 1;
      let isRequiredRemark = allData[itemCode].isRequiredRemark;
      let isRejectStatus = allData[itemCode].isRejectStatus
      statusFlag = (itemData[itemCode].statusFlag === '') ?
      clickButtonStatusFlag
      :
      itemData[itemCode].statusFlag //data base Statusflag
   
  
      if (buttonType === "REJECT" && isRejectStatus) {
        check++;
        if (isRequiredRemark) {
          toast.error(messages.REMARK_MSG, messages.COLOR_RED);
          return false;
        }
        if(isRejectStatus===true){
          statusFlag = 6 //clickButtonStatusFlag
        }
       
      }
     

      if (buttonType === "ACCEPT" || buttonType === "SAVE") { //Accept Button click
        statusFlag = clickButtonStatusFlag
      }

      if (buttonType === "SUBMIT") { //Submit Button click
        statusFlag = clickButtonStatusFlag;
      }

      if ((price === '' || price === null)) {
        price = "0.00";
      }

      if (isRequiredRemark && (comment === '' ||comment === 'NQ') ) {
        toast.error(messages.REMARK_MSG, messages.COLOR_RED);
        return false;
      }

      if (comment === '' || comment == null) {
        comment = 'NQ';
      }

      const customObject = {
        districtCode: districtCode,
        source: source,
        priceMonth: monthName < 10 ? `0${monthName}` : monthName,
        priceYear: yearName,
        itemCode: itemCode,
        price: price,
        status: isRejectStatus,
        statusFlag: statusFlag,
        comment: comment

      };

      customItemCodes.push(customObject);
    }

    
    if (buttonType === "REJECT" && check === 0) {
      toast.error(messages.CHECKBOX_REJECTION_MSG, messages.COLOR_RED);
      return false;
    }

    let postData = {
      itemCodes: customItemCodes,
      payload: {
        districtCode: districtCode,
        monthName: monthName < 10 ? `0${monthName}` : monthName,
        yearName: yearName,
        buttonType: buttonType,
        statusButtonFlag: clickButtonStatusFlag,
        dateName: dateName,
      }
    }
    console.log("final pOst Data", postData);

    showLoading(true);
    try {
      const response = await axios.post(`${API_URL}api/otherPrices/WholeSalePriceForAgricultureHapurMandiDataSaveToDB`, postData, config);
      if (response.data.status) {
        toast.success(response.data.message, messages.COLOR_RED);
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
      showLoading(false);
      resetForm();
    }




  }

  return (
    <>
      {/* <ToastContainer /> */}
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-bordered consumer_retail_table">
            {renderHeader(0)}
            <tbody>
              {hapurMandiItems && hapurMandiItems.map((item, i) => {

                if ((userInfoObject.userLevel === 'DISTRICT LEVEL' || userInfoObject.userLevel === 'DIVISION LEVEL')) {
                  districtAndDivision = true;
                }



                srNo = i
                // if (checkBoxcheckedLength() > 0) {
                //   isDisable = true
                // } else if (isAcceptBtnDisable) {
                //   isDisable = true
                // }

                if (checkBoxcheckedLength() > 0) {
                  isDisable = false
                } else if (payload.statusFlagSet === "6") {
                  if (isAcceptBtnDisable && checkBoxcheckedLength() !== 0) {
                    isDisable = true
                  }

                } else if (isAcceptBtnDisable) {

                  isDisable = false
                }


                return <React.Fragment>
                  <tr key={`row-${i}`}>
                    <td>{++srNo}</td>

                    <td>
                      {item.itemName}
                    </td>
                    <td>
                      {item.itemVarietyName}
                    </td>
                    <td>
                      {item.itemUnitName}
                    </td>
                    <td>
                      <input type="text"
                        style={itemData[item.itemCode]?.style || {}}
                        key={i}
                        className="form-control"
                        maxLength="15"
                        name={`price${i}`}
                        id={`price${i}`}
                        value={itemData[item.itemCode]?.price || ''}
                        onChange={e => handlePriceChange(item.itemCode, 'price', e.target.value)}
                        onBlur={e => validateItemVariationPrice(item.itemCode, 'style', parseFloat(e.target.value), item.average, item.varianceLimit)}
                      />
                    </td>

                    <td>
                    {
                          userInfoObject.userLevel === "HEAD QUARTER" ?
                          item.comment !== '' &&  !headQuarterRemark.includes(itemData[item.itemCode]?.comment) &&
                          otherRemark.includes(itemData[item.itemCode]?.comment) &&
                            <label className="text-danger" style={{ fontSize: '12px' }}>*{item.comment}</label>
                          
                          :
                          item.comment !== ''  &&  !otherRemark.includes(itemData[item.itemCode]?.comment) &&
                          headQuarterRemark.includes(itemData[item.itemCode]?.comment) &&
                            <label className="text-danger" style={{ fontSize: '12px' }}>*{item.comment}</label>
							
					          }

                    
                         <select
                            
                              name={`comment${i}`}
                              id={`comment${i}`}
                              className="form-select"
                              value={itemData[item.itemCode]?.comment || ''}
                              onChange={e => handlePriceChange(item.itemCode, 'comment', e.target.value)}
                            >
                              <option value="">[---Select---]</option>
                              	
                              { userInfoObject.userLevel === "HEAD QUARTER" ?
                          
                                  headQuarterRemark.map((remarkItem,i)=>{
                                    return (
                                    <option value={remarkItem} key={i}>{remarkItem}</option>
                  
                                  )})
                                 :
                        
                                  otherRemark.map((remarkItem,i)=>{
                                    return (
                                    <option value={remarkItem} key={i}>{remarkItem}</option>
                  
                                  )})
                               }

                            </select>



                      {(itemData[item.itemCode]?.isRequiredRemark !== undefined && itemData[item.itemCode]?.isRequiredRemark) ?
                        (
                          <div style={{ color: 'red', marginTop: '10px' }}>
                            Please Select the Remark
                          </div>
                        )
                        :
                        ''
                      }
                    </td>

                    <td className={itemData[item.itemCode]?.statusFlag === '6' ? 'checkbox_back_color' : ''}>
                      <input
                        disabled={districtAndDivision ? 'disabled' : ''}
                        type="checkbox"
                        name={`status${i}`}
                        id={`status${i}`}
                        onChange={(event) => handleCheckboxChange(item.itemCode, 'isRejectStatus', event.target.value)}
                        checked={itemData[item.itemCode]?.isRejectStatus || false}

                      />
                    </td>

                  </tr>

                </React.Fragment>
              })

              }
            </tbody>
          </table>
        </div>

        <div className="row">
          <div className="col-12 text-center pt-3">

              <button
                onClick={(e) => handleSaveHapurMandiFormData(e, 'SAVE')}
                type="button"
                className={`btn btn_orange mx-1 ${isSaveBtnDisable?'disabled':''}`}
                id='saved'
              >
                Save
              </button>
            

            {
              (userInfoObject.userLevel === 'DISTRICT LEVEL' || userInfoObject.userLevel === 'DIVISION LEVEL') &&
              <button
                onClick={(e) => handleSaveHapurMandiFormData(e, 'SUBMIT')}
                type="button"
                className={`btn btn_orange mx-1 ${isSubmitBtnDisable || checkBoxcheckedLength() > 0 ? 'disabled' : ''}`}
                id="submited"
              >
                Submit
              </button>
            }

            {
              (userInfoObject.userLevel === 'HEAD QUARTER') &&
              <>

                <button
                  onClick={(e) => handleSaveHapurMandiFormData(e, 'ACCEPT')}
                  type="button"
                  className={`btn btn_orange mx-1 ${isAcceptBtnDisable || checkBoxcheckedLength() > 0 ? 'disabled' : ''}`}
                  id='submited'
                >Accept
                </button>
                <button
                  onClick={(e) => handleSaveHapurMandiFormData(e, 'REJECT')}
                  type="button"
                  className={`btn btn_orange mx-1 ${isRejectBtnDisable ? 'disabled' : ''}`}
                  id="rejected"
                >Reject
                </button>
              </>

            }

            <button
              type="reset"
              className="btn btn_orange mx-1"
              onClick={resetForm}
            >
              Reset
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={(e) => (navigate("/dashboard"))}
            >
              Cancel
            </button>
          </div>
        </div>



      </div>
    </>
  )
}

export default WholeSalePriceForAgricultureItemsofHapurMandiData